import React from 'react';
import { Outlet, RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';

import { Route as TaskCenterRoute } from './_index';
import { PermissionsFn, PermissionGuard } from '~/core/PermissionGuard';

// Exports
export const permissions: PermissionsFn = (context) => {
  return context.flags.productsTasksCenterPermissions;
};
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  children: [{ index: true, element: <TaskCenterRoute /> }],
};
